import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class DeviceScriptFormatter extends Formatter {
}

// Каталог скриптов НАПРЯМУЮ к устройству (App\Models\DeviceScript, adb/ssh, БЕЗ android-сервиса,
// authorized/admin/devices/scripts) — read + редактирование label, kind='device'. Скрипты ЧЕРЕЗ
// android-сервис (reboot/reset и т.п.) — см. ApiRedroidScript (devices/redroid-scripts).
export default class ApiDeviceScript extends ApiModelWithAuth {
    pathDef = 'authorized/admin/devices/scripts';
    formatterItem = DeviceScriptFormatter.Item;
}
